import React from 'react';
import { iconAngleLeft, iconAngleRight } from '../../design-tokens';
import { ArrowIcon, StyledCustomArrow } from './CarouselArrows.styles';

const CarouselArrows = ({ carouselId, presentation, cardType }) => (
    <div>
        <StyledCustomArrow
            type="button"
            aria-label="Gå bakåt i lista"
            htmlFor={carouselId}
            value="left"
            direction="LEFT"
            presentation={presentation}
            cardType={cardType}
            disabled={true}
            tabIndex={-1}
        >
            <ArrowIcon icon={iconAngleLeft} />
        </StyledCustomArrow>

        <StyledCustomArrow
            type="button"
            aria-label="Gå framåt i lista"
            htmlFor={carouselId}
            value="right"
            direction="RIGHT"
            presentation={presentation}
            cardType={cardType}
            tabIndex={-1}
        >
            <ArrowIcon icon={iconAngleRight} />
        </StyledCustomArrow>
    </div>
);

export default CarouselArrows;
